var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"confirm-sent-modal","title":"Confirm","ok-variant":"primary","ok-title":"Save","ok-disabled":_vm.isProcessing},on:{"ok":_vm.createSnapshot}},[_vm._v(" Do you want to send this? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }